<template>
  <!--  只允许一个 组件 -->
  <a-layout style="padding-top: 65px;">
    <!--中间布局-->
    <a-layout>
      <!-- 查询&新增-->
      <a-layout style="margin: 10px">
        <a-form layout="inline" :model="param">
          <a-form-item>
            <a-input v-model:value="param.title" placeholder="请输入标题" :allowClear="true">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-cascader v-model:value="param.categoryIds"
              :field-names="{ label: 'name', value: 'id', children: 'children' }" :options="level1" change-on-select
              placeholder="请选择分类" style="width: 200px;" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="resetQuery" style="background: #E6A23C">
              重置
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleQuery({ page: 1, size: pagination.pageSize })">
              查询
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="add()">
              新增
            </a-button>
          </a-form-item>
        </a-form>
      </a-layout>

      <!--中间详文章列表-->
      <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
        <!--文章列表 -->
        <!-- :row-key="record => record.id" -->
        <a-table :columns="columns" :data-source="articles" :pagination="pagination" :loading="loading"
          @change="handleTableChange">
          <!-- <template v-slot:headerCell="{ column, record }"></template> -->
          <template v-slot:bodyCell="{ column, record }"> <!-- { text, record } -->
            <!-- 注意：如果设置了v-slot:bodyCell，所有column都会“进入”到插槽，需在插槽内自行过滤掉不使用插槽的情况。` -->
            <template v-if="column.dataIndex === 'coverUrl'">
              <a-image v-if="record.coverUrl" :width="52" :preview="true" :src="record.coverUrl" alt="avatar" />
            </template>
            <template v-if="column.dataIndex === 'category'">
              <span>{{ record.category1.name }} / {{ record.category2.name }}</span>
            </template>
            <template v-if="column.dataIndex === 'status'">
              <a-tag v-if="record.status == 0" color="orange">未发布</a-tag>
              <a-tag v-else-if="record.status == 1" color="green">已发布</a-tag>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <a-space size="small">
                <!-- 新页面打开 -->
                <!-- 代码编码 window.open(routeUrl.href, '_blank'); -->
                <router-link :to="'/doc?articleId=' + record.id" slots="a" target="_blank">
                  <a-button type="primary">
                    预览
                  </a-button>
                </router-link>
                <router-link :to="'/admin/doc?articleId=' + record.id" target="_blank">
                  <a-button type="primary">
                    内容编辑
                  </a-button>
                </router-link>
                <a-button type="primary" @click="edit(record)">
                  编辑
                </a-button>
                <!-- 发布or撤销 -->
                <a-popconfirm title="确认执行操作?" ok-text="是" cancel-text="否" @confirm="publish(record)">
                  <a-button type="primary" :danger="record.status == 1" ghost>
                    <span v-if="record.status == 0">发布</span>
                    <span v-else-if="record.status == 1">撤销</span>
                  </a-button>
                </a-popconfirm>
                <!-- 推荐文章 -->
                <a-button type="primary" @click="recommend(record)" style="background: #67C23A">
                  推荐
                </a-button>
                <!-- 删除 -->
                <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                  <a-button type="primary" danger>
                    删除
                  </a-button>
                </a-popconfirm>
              </a-space>
            </template>
          </template>
        </a-table>

      </a-layout-content>
    </a-layout>

    <!-- 模态弹出框-->
    <a-modal title="文章表单" v-model:open="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
      <a-form :model="article" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="封面">
          <a-input v-model:value="article.cover" :disabled="true" :allowClear="true" />
          <!-- 上传控件 -->
          <!-- ！！！注意 name中的file要和后台 @RequestBody MultipartFile file 中的file同名 ！！！ -->
          <a-upload v-model:file-list="fileList" name="file" list-type="picture-card" class="avatar-uploader"
            :show-upload-list="false" :action="SERVER + '/file/upload/avatar'" :before-upload="beforeUpload"
            :headers="uploadHeaders" @change="handleChange">
            <template v-if="imageUrl">
              <img :src="imageUrl" alt="avatar" />
            </template>
            <template v-else>
              <div>
                <loading-outlined v-if="coverLoading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传</div>
              </div>
            </template>
          </a-upload>
        </a-form-item>
        <a-form-item label="分类">
          <a-cascader v-model:value="categoryIds" :field-names="{ label: 'name', value: 'id', children: 'children' }"
            :options="level1" placeholder="请选择分类" />
        </a-form-item>
        <a-form-item label="标题">
          <a-input v-model:value="article.title" :allowClear="true" placeholder="请输入标题" />
        </a-form-item>
        <a-form-item label="描述">
          <a-input v-model:value="article.description" type="textarea" :allowClear="true" placeholder="请输入描述" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>


</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import store from "@/store";
import TheFooter from "@/components/the-footer.vue";


export default defineComponent({
  name: 'AdminArticle',
  components: {
    TheFooter
  },
  setup() {
    const param = ref();
    param.value = {};
    const articles = ref();
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const loading = ref(false);

    const columns = [
      {
        title: '封面',
        dataIndex: 'coverUrl',
      },
      {
        title: '标题',
        dataIndex: 'title'
      },
      {
        title: '分类',
        dataIndex: 'category',
      },
      {
        title: '描述',
        dataIndex: 'description'
      },
      {
        title: '摘要',
        dataIndex: 'summary'
      },
      {
        title: '阅读数',
        dataIndex: 'viewCount',
        width: 80
      },
      {
        title: '点赞数',
        dataIndex: 'voteCount',
        width: 80
      },
      {
        title: '发布状态',
        dataIndex: 'status',
      },
      {
        title: 'Action',
        dataIndex: 'action',
      }
    ];

    /**
     * 数据查询
     **/
    const handleQuery = (params: any) => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      articles.value = [];
      // 处理分类选择
      console.log('params', params)
      let _categoryIds: any = param.value.categoryIds
      console.log('categoryIds', _categoryIds) //undefined,一级 [100], 二级 [100,102]
      let categoryId1 = undefined
      let categoryId2 = undefined
      if (_categoryIds != undefined) {
        // 处理分类ID
        if (_categoryIds.length == 1) {
          categoryId1 = _categoryIds[0];
        } else if (_categoryIds.length == 2) {
          categoryId1 = _categoryIds[0];
          categoryId2 = _categoryIds[1];
        }
      }

      axios.post("/article/list", {
        // 后台Get方法参数
        // params: {}

        // 后台Post方法参数
        page: params.page,
        size: params.size,
        title: param.value.title,
        categoryId1: categoryId1,
        categoryId2: categoryId2,
      }).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          articles.value = result.data.list;

          // 重置分页按钮
          pagination.value.current = params.page;
          pagination.value.total = result.data.total;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
 * 重置
 */
    const resetQuery = () => {
      console.log('resetQuery ... ')
      // 清空表单
      param.value.title = undefined
      param.value.categoryIds = undefined
      // 重新查询
      handleQuery({
        page: 1,
        size: 10,
      });
    };


    /**
     * 表格点击页码时触发
     */
    const handleTableChange = (pagination: any) => {
      //{current: 2, pageSize: 2, total: 5}
      console.log("自带的分页参数：", pagination);
      // 查询数据
      handleQuery({
        page: pagination.current,
        size: pagination.pageSize
      });
    };


    // ------------------------ 表单 ------------------------
    /**
     * 数组，[100, 101]对应：前端开发 / Vue
     */
    const categoryIds = ref();
    const article = ref();
    const modalVisible = ref(false);
    const modalLoading = ref(false);
    const handleModalOk = () => {
      console.log('article', article.value)
      console.log('categoryIds', categoryIds.value)

      // 校验数据
      if (article.value.title == undefined || article.value.title.trim() == ''
        || article.value.description == undefined || article.value.description.trim() == ''
        || categoryIds.value == undefined
      ) {
        message.warning('请补全数据')
        return
      }

      modalLoading.value = true;
      article.value.category1Id = categoryIds.value[0];
      article.value.category2Id = categoryIds.value[1];
      axios.post("/article/save", article.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑
     */
    const edit = (record: any) => {
      console.log('edit ', record)
      modalVisible.value = true;
      article.value = Tool.copy(record);
      imageUrl.value = record.coverUrl
      categoryIds.value = [article.value.category1Id, article.value.category2Id]
    };

    /**
     * 发布
     * @param record 
     */
    const publish = (record: any) => {
      console.log('publish ', record)
      loading.value = true;
      axios.post("/article/publish", { id: record.id }).then((response) => {
        loading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('操作成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 推荐文章
     * @param record 
     */
    const recommend = (record: any) => {
      console.log('recommend ', record)
      loading.value = true;
      axios.get("/article/recommend/" + record.id).then((response) => {
        loading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('操作成功')
        } else {
          // 40000
          if (result.code == 40000) {
            message.warning(result.message);
          } else {
            message.error(result.message);
          }
        }
      });
    };

    /**
     * 新增
     */
    const add = () => {
      modalVisible.value = true;
      article.value = {};       // 文章数据
      imageUrl.value = '';    // 图片封面图链接
      categoryIds.value = []; // 文章分类
    };

    /**
     * 删除
     * @param id
     */
    const handleDelete = (id: number) => {
      axios.delete("/article/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };


    const level1 = ref();
    let categorys: any;

    /**
     * 查询所有分类
     **/
    const handleQueryCategory = () => {
      loading.value = true;
      axios.get("/category/all").then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          categorys = result.data.list;
          console.log("原始数组：", categorys);

          level1.value = [];
          level1.value = Tool.array2Tree(categorys, 0);
          console.log("树形结构：", level1.value);

        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 取出分类名称
     * @param cid
     */
    const getCategoryName = (cid: number) => {
      // console.log(cid)
      let result = "";
      categorys.forEach((item: any) => {
        if (item.id === cid) {
          // return item.name; // 注意，这里直接return不起作用
          result = item.name;
        }
      });
      return result;
    };

    // ------------------------ 上传 ------------------------
    const SERVER = process.env.VUE_APP_SERVER;
    const fileList = ref([]);
    const coverLoading = ref<boolean>(false);
    const imageUrl = ref<string>('');
    const uploadHeaders = ref({});

    const handleChange = (info: any) => {
      console.log('upload info', info)
      // status: 'done', // 状态有： uploading done error removed

      // 正在上传文件
      if (info.file.status === 'uploading') {
        coverLoading.value = true;
        return;
      }

      // 上传完毕
      if (info.file.status === 'done') {

        /**
         * 上传成功，服务器返回
         * {
            "code": 0,
            "message": "success",
            "data": {
                "fileName": "68a720e35de14ca8a926dbe3fcb2b344.png",
                "fileUrl": "http://localhost:8080/wiki-biz/images/68a720e35de14ca8a926dbe3fcb2b344.png"
            }
          }
         */
        let result = info.file.response
        console.log('result', result)
        coverLoading.value = false;
        if (result.code == 0 && result.message == 'success') {
          // 修改文件名
          article.value.cover = result.data.fileName
          // 修改图片链接
          imageUrl.value = result.data.fileUrl
        } else {
          message.error(result.message)
        }
      }

      // 上传出错
      if (info.file.status === 'error') {
        coverLoading.value = false;
        message.error('upload error');
      }
    };


    const beforeUpload = (file: any) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('图片必须小于2MB!');
      }
      // 修改请求头，携带token
      console.log('user => ', store.state.user)
      uploadHeaders.value = { "blog-token": store.state.user.token }

      return isJpgOrPng && isLt2M;
    };

    onMounted(() => {

      // 加载分类
      handleQueryCategory();

      // 加载文章列表
      handleQuery({
        page: 1,
        size: pagination.value.pageSize,
      });

    });

    return {
      param,
      articles,
      pagination,
      columns,
      loading,
      edit,
      publish,
      recommend,
      handleQuery,
      handleTableChange,
      modalVisible,
      article,
      handleModalOk,
      add,
      modalLoading,
      handleDelete,
      resetQuery,

      getCategoryName,
      categoryIds,
      level1,


      fileList,
      coverLoading,
      imageUrl,
      handleChange,
      beforeUpload,
      uploadHeaders,
      SERVER
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
